import * as React from 'react'

import type {HOC} from '../types'
import {wrapDisplayName} from '../utils/getDisplayName'

export default function withWrapper<P>(
  getWrapper: (arg0: P) => (React.ComponentType<any> | null | undefined) | string,
): HOC<P, P> {
  return BaseComponent => {
    function WithWrapper(props: P) {
      const Wrapper = getWrapper(props) ?? React.Fragment
      return (
        <Wrapper>
          <BaseComponent {...props} key={undefined} />
        </Wrapper>
      )
    }

    if (process.env.NODE_ENV !== 'production') {
      WithWrapper.displayName = wrapDisplayName(BaseComponent, 'withWrapper')
    }

    return WithWrapper
  }
}
